import {Link} from 'react-router-dom';
import {Helmet} from 'react-helmet-async';
import React from 'react';
import './Sitemap.css';
import soltLogo from '../assets/logo.png';
import {SEO_PUBLISHED_CITIES, geoBestRestaurantsPath, geoCityPath} from '../data/geoRoutes';
import {BRAND_TAGLINE, BRAND_TITLE} from '../constants/brand';
import {APP_STORE_URL} from '../constants/app';

const Sitemap = () => {
    const canonicalUrl = 'https://solt.app/sitemap';

    return (
        <div className="sitemap-page">
            <Helmet>
                <title>Sitemap | {BRAND_TITLE}</title>
                <meta name="description" content="Solt site map — homepage, city guides, app download, and legal pages."/>
                <link rel="canonical" href={canonicalUrl}/>
            </Helmet>
            <div className="sitemap-page top-navigation">
                <div className="nav-content">
                    <Link to="/" className="logo-link">
                        <img src={soltLogo} alt="Solt logo" className="solt-logo"/>
                    </Link>
                    <a
                        href={APP_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ios-app-button-link"
                        aria-label="Download the Solt iOS app"
                    >
                        <button type="button" className="join-creator-button">Download Solt</button>
                    </a>
                </div>
            </div>

            <div className="page-content-container">
                <h1 className="hero-title" style={{fontSize: '1.5rem', textAlign: 'center'}}>
                    Sitemap
                </h1>
                <section className="sitemap-section">
                    <div className="sitemap-links-list">
                        <Link to="/">Home</Link>
                        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
                            Download on the App Store
                        </a>
                        <Link to="/privacy">Privacy policy</Link>
                        <Link to="/terms">Terms of service</Link>
                        <Link to="/cookies">Cookie policy</Link>
                    </div>
                </section>
                {SEO_PUBLISHED_CITIES.map((geo) => (
                    <section key={`${geo.countrySlug}-${geo.citySlug}`} className="sitemap-section">
                        <h2 style={{fontSize: '1.2rem'}}>
                            {geo.cityName}, {geo.countryName}
                        </h2>
                        <div className="sitemap-links-list">
                            <Link to={geoCityPath(geo)}>Where to eat in {geo.cityName}</Link>
                            <Link to={geoBestRestaurantsPath(geo)}>Best restaurants in {geo.cityName}</Link>
                        </div>
                    </section>
                ))}
            </div>

            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-top">
                        <img src={soltLogo} alt="Solt logo"/>
                        <div className="footer-top-text">{BRAND_TAGLINE}</div>
                    </div>
                    <div className="footer-bottom">Made in Europe ❤️</div>
                </div>
            </footer>
        </div>
    );
};

export default Sitemap;
